const AUTH_SESSION_KEY = 'authSession';
const REMEMBER_ME_KEY = 'rememberMe';

const readPreferenceStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const rememberMe = window.localStorage.getItem(REMEMBER_ME_KEY) === 'true';
  return rememberMe ? window.localStorage : window.sessionStorage;
};

export const hasAuthSession = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return (
    window.sessionStorage.getItem(AUTH_SESSION_KEY) === '1' ||
    window.localStorage.getItem(AUTH_SESSION_KEY) === '1'
  );
};

export const isRememberMeEnabled = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.localStorage.getItem(REMEMBER_ME_KEY) === 'true';
};

export const persistAuthSession = (input: { rememberMe: boolean }) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(REMEMBER_ME_KEY, String(input.rememberMe));

  const primary = input.rememberMe
    ? window.localStorage
    : window.sessionStorage;
  const secondary = input.rememberMe
    ? window.sessionStorage
    : window.localStorage;

  primary.setItem(AUTH_SESSION_KEY, '1');
  secondary.removeItem(AUTH_SESSION_KEY);
};

export const clearAuthTokens = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(AUTH_SESSION_KEY);
  window.localStorage.removeItem(REMEMBER_ME_KEY);
  window.sessionStorage.removeItem(AUTH_SESSION_KEY);

  // legacy cleanup — tokens must not remain readable by JS
  window.localStorage.removeItem('accessToken');
  window.localStorage.removeItem('refreshToken');
  window.sessionStorage.removeItem('accessToken');
  window.sessionStorage.removeItem('refreshToken');
};

/** @deprecated Tokens live in httpOnly cookies; kept for call-site compatibility. */
export const getAccessToken = (): string | null => null;

/** @deprecated Tokens live in httpOnly cookies; kept for call-site compatibility. */
export const getRefreshToken = (): string | null => null;

/** @deprecated Prefer persistAuthSession — JWTs are not stored in JS. */
export const persistAuthTokens = (input: {
  accessToken: string;
  refreshToken: string;
  rememberMe: boolean;
}) => {
  persistAuthSession({ rememberMe: input.rememberMe });
};

export const setAccessToken = (_accessToken: string) => {
  const storage = readPreferenceStorage();
  storage?.setItem(AUTH_SESSION_KEY, '1');
};

export const setRefreshToken = (_refreshToken: string) => {
  const storage = readPreferenceStorage();
  storage?.setItem(AUTH_SESSION_KEY, '1');
};
